import React from 'react';
import { Link } from 'react-router-dom';
import { NEW_TAB_LINK_PROPS } from 'framework/utils';
import { useEmployeeUrl } from './route/hooks/useEmployeeUrl';

export interface EmployeeLinkProps {
  id?: Nullable<string>;
  name: string | React.ReactNode;
  isOpenInNewTab?: boolean;
  isLink?: boolean;
}

const EmployeeLink = ({ id, name, isOpenInNewTab, isLink = true }: EmployeeLinkProps) => {
  const { getSingleEntityUrl } = useEmployeeUrl();

  return (
    <>
      {id && isLink ? (
        <Link
          to={getSingleEntityUrl(id)}
          {...(isOpenInNewTab && NEW_TAB_LINK_PROPS)}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          {name}
        </Link>
      ) : (
        <span>{name}</span>
      )}
    </>
  );
};

export default EmployeeLink;
